export const SchemaUser = {
  name: "",
  birthDay: "",
  lastNames: "",
  phoneNumber: "",
  email: "",
  password: "",
  streetName: "",
  colonia: "",
  state: "",
  CP: "",
  direction: "",
  coordinates: {
    latitude: 0,
    longitude: 0,
  },
  homeNumber: "",
  houseNumber: "",
  dateCreated: "",
  conecktaId: "",
  profileUrl: "",
  uid: "",
};

export const SchemaAdmin = {
  name: "",
  lastNames: "",
  phoneNumber: "",
  email: "",
  password: "",
  type: "",
};

export const CarSchema = {
  nickName: "",
  model: "",
  year: "",
  serial: "",
  plates: "",
  color: "",
  mexicoProtectID: "",
  pictures: [],
  user: "",
};

export const ContactSchema = {
  name: "",
  phoneNumber: "",
  relation: "",
  user: "",
};

export const ReportSchema = {
  dateReported: "",
  title: "",
  direction: "",
  description: "",
  coordinates: {
    latitude: 0,
    longitude: 0,
  },
  status: "",
  user: "",
};

export const ComplaintSchema = {
  user: "",
  complaintReasonStolen: "",
  coordinates: {
    latitude: 0,
    longitude: 0,
  },
  modelCar: "",
  brandCar: "",
  platesCar: "",
  colorCar: "",
  images: [],
  videos: [],
  place: {
    neighborhood: "",
    street: "",
    city: "",
    state: "",
    reference: "",
  },
  time: "",
  probableGuilty: "",
  comments: "",
};
